<form autocomplete="off" [formGroup]="formName" [ngClass]="{ row: formStyle === 'HORIZONTAL' }" (ngSubmit)="onSubmit()">
  <ng-content> </ng-content>
  <ui-fh-required-notes class="mt-3" *ngIf="showNotes"></ui-fh-required-notes>
  <div
    *ngIf="showFormBtn"
    [id]="submitBtnId"
    class="col-12 d-flex btns-display justify-content-{{ submitLabelClassPosition }}"
    [ngClass]="{
      'mt-3': formStyle === 'VERTICAL',
      'footer-container-mobile': stickyBtn
    }">
    <ng-container *ngIf="extraBtn">
      <ui-fh-button
        [disabled]="btnDisabled"
        [severity]="'secondary'"
        [chosenType]="'button'"
        [style.min-width]="btnMinWidth ? btnMinWidth + 'px' : 'unset'"
        [class]="extraBtnClass"
        [label]="extraBtnLabel"
        [icon]="icon + ' ' + extraBtnIcon"
        [iconPos]="'left'"
        (click)="onExtraBtnClick()"></ui-fh-button>
    </ng-container>
    <ng-container *ngIf="submitIconOnly">
      <ui-fh-button [severity]="'secondary'" [class]="getStylesButton()" [icon]="submitIcon" [tooltip]="submitLabel"></ui-fh-button>
    </ng-container>
    <ng-container *ngIf="!submitIconOnly">
      <ui-fh-button
        [loading]="btnLoading"
        [disabled]="(btnAllowDisableAuto && formName.invalid) || btnDisabled"
        [style.min-width]="btnMinWidth ? btnMinWidth + 'px' : 'unset'"
        [icon]="icon + ' ' + submitIcon"
        [class]="getStylesButton()"
        [label]="submitLabel"></ui-fh-button>
    </ng-container>
  </div>
</form>
